import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import useMarketShareHooks from 'src/components/AtlasV2Components/Hooks/useMarketShareRequestHook';
import { METRICTYPE } from 'src/utils/entityDefinitions';

/**
 *
 * Market Share without one p three p enabled spline chart
 */
const AtlasV2UnitsSoldMarketShareSplineChart = () => {
  const { requestBuilder, marketShareBuilder } = useMarketShareHooks();
  return (
    <AtlasV2ComparableSplineChart
      fieldName="unitsSold"
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      title="Market Share Trend"
      marketShareKey={['unitsSold_sum_value', 'unitsSold_sum_value']}
      requestBuilder={requestBuilder}
      marketShareBuilder={marketShareBuilder}
    />
  );
};

export default AtlasV2UnitsSoldMarketShareSplineChart;
